module.exports = "<app-sidebar></app-sidebar>\r\n<app-advert></app-advert>\r\n"